import styled from "styled-components";
import { IMAGES } from "../../constants/images";

export default function CalculateContainer({ handleClick, color, title, children }) {
  return (
    <CalculatedResultsContainer riskColor={color}>
      <div className="header">
        <h2>{title}</h2>
        <button onClick={() => handleClick(false)} title="Close">
          <img src={IMAGES.CLOSE} alt="Close" />
        </button>
      </div>
      {children}
    </CalculatedResultsContainer>
  );
}

const CalculatedResultsContainer = styled.div`
  position: relative;
  width: 320px;
  padding: 15px;
  border-radius: 8px;
  font-size: 14px;
  overflow: hidden;
  z-index: 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, #ffffff, ${({ riskColor }) => riskColor});
    z-index: -2;
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    z-index: -1;
  }

  .analysed-parameters {
    margin: 10px 0 0 0;
    padding: 0;
    list-style: none;
  }

  .wildfire-risk {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    margin: 10px 0;
  }

  .wildfire-text {
    margin: 0 0 10px 0;
  }

  .analysed-title {
    padding: 0;
    margin: 10px 0 5px 0;
  }

  .analysed-parameters-info {
    margin: 0;
    padding-left: 25px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
      display: flex;
      align-items: center;
      margin: 0;
      font-size: 16px;
    }

    h2::before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      background-color: ${({ riskColor }) => riskColor};
      border-radius: 50%;
      margin-right: 8px;
    }

    button {
      all: unset;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img {
        width: 14px;
      }
    }
  }

  .show-parameters {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;

    img {
      width: 10px;
    }
  }

  .division-sections {
    height: 1px;
    background-color: black;
    border: none;
  }
`;
